import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment } from "semantic-ui-react";

import { Form, Formik, Field, useFormik } from "formik";
import Swal from "sweetalert2";

import * as Yup from "yup";
import ReactToPrint from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MyTextInput, { MyTextInputConvD, MyTextInputConv, MyTextAreatConv, MyTextInputFechas } from "../../../app/common/form/MyTextInput";

import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "../src/css/convenios.css";
import Num2Let from "./Num2Let";
import { MilesQuota } from "./MilesQuota";

let ImpHeadDate = new Date().toLocaleDateString('es-GT', { day: "numeric", month: "long", year: "numeric" }),
  notasBasic: string = "Notas: * La institución debe cancelar el costo por las personas inscritas (el trámite de pago se debe establecer antes de finalizar el curso). * Al iniciar el curso no se podrá eliminar y/o hacer cambios de participantes. * El INAP enviará Diplomas digitales a cada participante aprobado al finalizar el curso. * Se solicita que en el oficio de aceptación de la presente cotización, se proporcione los datos de la persona que será el enlace (nombre, cargo, correo electrónico y número telefónico) con quien la Dirección Financiera del INAP, deberá comunicarse para dar seguimiento al proceso de pago. * Para dar seguimiento a la presente cotización, es necesario que el solicitante remita un oficio de aceptación o bien, si ya se emitió la Solicitud de Compra de Bienes y/o Servicios, una copia de la misma. * Al aceptar la cotización, se trasladará un código para que cada participante pueda registrarse en la plataforma de INAP y realizar su proceso de inscripción al curso",
  cuerpoSaludo: string = "Reciban un cordial saludo del Instituto Nacional de Administración Pública, en atención a su solicitud y de acuerdo con las necesidades de capacitación de su personal, se presenta propuesta, la cual se detalla a continuación:";

let
  cotiId: number,
  montoT: number,
  sMonto: number,
  descripcion: string,
  fetchData: any;
;

let csaludo: string,
  cscuerpo: string,
  nomfirma: string,
  firpuesto: string,
  firdepend: string,
  cotfdesde: any,
  cotfhasta: any,
  cotarchivo: string;

export default observer(function AddModalCotizaciones(

  COT: {
    show: any,
    onHide: any,
    idCoti: any,
    idConv: any,
    correlativo: any,
    dependencia: any,
    destinatario: any,
    saludo: string,
    descripcion: any,
    notas: any,
    nombre: any,
    puesto: any,
    archivo: any,
    startedAt: any,
    endedAt: any,

    dependenciaIni: any,
    descripcionIni: any,
    destinatarioIni: any,

    catCursoNombre: any,
    catCursoModalidad: any,
    participantes: any,
    fechaInicio: any,
    fechaFinal: any,
    catCursoMonto: any,
    monto: any,
    descuento: any
  }
) {

  interface MyFormValues {
    id: number,
    convenio: number,
    correlativo: string,
    dependencia: string,
    destinatario: string,
    saludo: string,
    descripcion: string,
    notas: string,
    nombre: string,
    puesto: string,
    archivo: string,
    startedAt: string,
    endedAt: string
  }

  interface DataCoti {
    saludo: string,
    descripcion: string,
    nombre: string,
    puesto: string,
    dependencia: string,
    startedAt: any,
    endedAt: any,
    archivo: string
  }

  const apiURL = process.env.REACT_APP_API_URL + '/CATCotizaciones';
  const [isCheckedCap, setIsCheckedCap] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);
  // const [datac, setDatac] = useState<DataCoti[]>([]);
  const [datac, setDatac] = useState<any>(null);

  function handleCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
    setIsCheckedCap(e.target.checked);
  }

  const initialValues: MyFormValues = {
    id: COT.idCoti ? COT.idCoti : 0,
    convenio: COT.idConv,
    correlativo: COT.correlativo,
    dependencia: COT.dependencia ? COT.dependencia : COT.dependenciaIni,
    descripcion: COT.descripcion ? COT.descripcion : cuerpoSaludo,
    destinatario: COT.destinatario ? COT.destinatario : COT.destinatarioIni,
    saludo: COT.saludo ? COT.saludo : "Estimados",
    notas: notasBasic,
    nombre: COT.nombre,
    puesto: COT.puesto ? COT.puesto : "Director",
    archivo: COT.archivo ? COT.archivo : "C.C. Archivo",
    startedAt: COT.startedAt,
    endedAt: COT.endedAt
  }

  const validationSchema = Yup.object({

    archivo: Yup.string()
      .min(5, 'Extiendete mas en denotar el archivo.')
      .max(90, 'No puedes ingresar mas de 50 letras')
      .nullable(true),

    nombre: Yup.string()
      .required('Requerido')
      .min(5, 'Ingresa un nombre y como mínimo un apellido')
      .max(90, 'No puedes ampliarte con mucho texto')
      .nullable(true),

    puesto: Yup.string()
      .min(5, 'Describe el puesto de quien emite la cotización')
      .max(90, 'No puedes ingresar un saludo tan extenso.')
      .nullable(true),

    saludo: Yup.string()
      .min(5, 'Extiendete mas en el saludo.')
      .max(90, 'No puedes ingresar un saludo tan extenso.')
      .nullable(true),

    descripcion: Yup.string()
      .min(20, 'Extiendete mas en el saludo.')
      .max(300, 'No puedes ingresar un saludo tan extenso.'),

    startedAt: Yup.string()
      .required('Requerido'),

    endedAt: Yup.string()
      .required('Requerido')

  });

  function ExitMsj() {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Código Institucional Cotizado",
      text: 'la cotización ha sido generada satisfactoriamente.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  function ExitMsjError() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "Error",
      text: 'Ha ocurrido un error en la actualización, por favor verifica que la informacion sea correcta e intenta de nuevo.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  cotiId = COT?.idCoti;
  const getDetallesCot = async () => {
    const apiurlc = process.env.REACT_APP_API_URL + `/CATCotizaciones/${cotiId ? cotiId : null}`;
    const respen = await fetch(apiurlc);
    const dataen = await respen.json();
    setDatac(dataen);
  };

  useEffect(() => { getDetallesCot() }, [cotiId]);

  const getSubmitHandler = (saving: any) => (values: any, formik: any) => {
    const endpoint = saving
      ? apiURL
      : apiURL;
    return fetch(endpoint, {
      method: cotiId == 0 || cotiId == undefined || cotiId == null ? 'POST' : 'PUT',
      body: JSON.stringify(values),
      headers: { "Content-Type": "application/json" }
    }).then(function (r) {
      if (r.status == 200) {

        getDetallesCot();

        // setTimeout(
        //   getDetallesCot, 2000
        // );

        return ExitMsj();
      } else { ExitMsjError(); }
    });
  };



  return (

    <>

      <Modal
        {...COT}
        size="lg"
        className="modal-add-dep-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}

          onSubmit={(values, { setSubmitting }) => {
            getSubmitHandler(values);
            setSubmitting(false);
          }}
        >
          {formik => (
            <>
              <Modal.Header closeButton >
                <Modal.Title id="contained-modal-title-vcenter">
                  Generar cotización
                </Modal.Title>
              </Modal.Header>
              <Form>

                <Modal.Body className="modal-dep-area">

                  {datac && (
                    <>

                      <Container id="coti-area" className={'form-cotizacion-area'} >

                        <div className="form-header">
                          <h3>Los valores de la cotización son tomados del código creado, ademas puedes modificar algunos textos necesarios para generar la cotización.</h3>
                        </div>

                        <Row>
                          <Col>
                            <MyTextInputConv
                              label="Saludo"
                              placeholder="Ingresa el saludo"
                              type="input"
                              id="saludo"
                              name="saludo"
                              defaultValue={datac?.saludo ? datac?.saludo : "Estimados:"}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <MyTextAreatConv
                              label="Cuerpo del saludo"
                              placeholder=""
                              type="input"
                              id="descripcion"
                              name="descripcion"
                              defaultValue={datac?.descripcion ? datac?.descripcion : cuerpoSaludo}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <MyTextInputConv
                              label="Nombre de quien firma:"
                              placeholder=""
                              type="input"
                              id="nombre"
                              name="nombre"
                              defaultValue={datac?.nombre ? datac?.nombre : "Nombre de quien firma"}
                            />
                          </Col>

                          <Col>
                            <MyTextInputConv
                              label="Puesto"
                              placeholder=""
                              type="input"
                              id="puesto"
                              name="puesto"
                              defaultValue={datac?.puesto ? datac?.puesto : "Director"}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <MyTextInputConv
                              label="Dependencia firmante"
                              placeholder=""
                              type="input"
                              id="dependencia"
                              name="dependencia"
                              defaultValue={datac?.dependencia ? datac?.dependencia : "Dirección para el Fortalecimiento de la Gestión Institucional"}
                            />
                          </Col>
                          <Col>
                            <MyTextInputConv
                              label="Con copia a:"
                              placeholder=""
                              type="input"
                              id="archivo"
                              name="archivo"
                              defaultValue={datac?.archivo ? datac?.archivo : "C.C. Archivo"}
                            />
                          </Col>
                        </Row>

                        <p>Validez de la cotización <span>"tiempo en que se sostiene la cotización"</span>:</p>
                        <Row>

                          <Col>
                            <MyTextInputFechas
                              label="Desde"
                              placeholder=""
                              id="startedAt"
                              name="startedAt"
                              defaultValue={calculoFechas(datac?.startedAt)}
                              onFocus={(e: any) => (e.currentTarget.type = "date")}
                              onBlur={(e: any) => (e.currentTarget.type = "date")}
                            />
                          </Col>

                          <Col>
                            <MyTextInputFechas
                              label="Hasta"
                              placeholder=""
                              id="endedAt"
                              name="endedAt"
                              defaultValue={calculoFechas(datac?.endedAt)}
                              onFocus={(e: any) => (e.currentTarget.type = "date")}
                              onBlur={(e: any) => (e.currentTarget.type = "date")}
                            />
                          </Col>

                        </Row>

                        <Row className="print-options">

                          <Col xs={2}>
                            <label className="switchCap">
                              <input type="checkbox" checked={isCheckedCap} onChange={handleCheckboxChange} />
                              <span className="sliderCap round"></span>
                            </label>
                          </Col>

                          <Col xs={10}>
                            <p>Utiliza esta opción para capitalizar las cantidades de tu impresion.</p>
                          </Col>

                        </Row>

                      </Container>

                    </>
                  )}

                </Modal.Body>

                <Modal.Footer>
                  <Col>
                    <Button variant="primary"
                      disabled={!(formik.isValid && formik.dirty)}
                      onClick={event =>
                        getSubmitHandler({
                          saving: true,
                          enableReinitialize: true,
                          validationSchema
                        })(formik.values, formik.isValid)
                      }> Generar cotizacion
                    </Button>
                  </Col>

                  <ReactToPrint
                    trigger={() => (
                      <Button
                        // onClick={getDetallesCot}
                        variant="primary"
                        className="link primary"
                        type="button"
                      >
                        Imprimir cotización
                      </Button>
                    )}
                    content={() => componentRef.current}
                  />

                </Modal.Footer>
              </Form>

              <div className="cuerpo-impresion" ref={componentRef}>
                {impresionConvenio()}
              </div>

            </>

          )}
        </Formik>

      </Modal>

    </>

  );

  function impresionConvenio() {
    return (
      <Container className="convenio-print-area">

        {
          datac && (
            <>

              <Container className="convenio-body-area">

                <Container className="head-date">
                  <p>{"Guatemala: " + ImpHeadDate}</p>
                  <p><span>REF: {COT?.correlativo}</span></p>
                </Container>

                <Container className="convenio-psaludo">
                  <p>Señores: {COT?.destinatario}</p>
                  <p>Ciudad de Guatemala</p>
                  <br />
                  <br />
                  <p>{datac.saludo ? datac.saludo : "Estimados:"}</p>
                  <br />
                  <p>{datac?.descripcion ? datac?.descripcion : "Reciban un cordial saludo del Instituto Nacional de Administración Pública, en atención a su solicitud y de acuerdo con las necesidades de capacitación de su personal, se presenta propuesta, la cual se detalla a continuación:"}</p>
                </Container>

                <Container className="convenio-print-table">
                  <Row className="header-print-table">
                    <Col md={4} className="col-md" >
                      <p className="titulo-column-imp">Nombre del Curso o Diplomado</p>
                    </Col>

                    <Col md={2} className="col-md">
                      <p className="titulo-column-imp">Modalidad</p>
                    </Col>

                    <Col className="col-md">
                      <p className="titulo-column-imp">Participantes</p>
                    </Col>

                    <Col>
                      <p className="titulo-column-imp">Duracion</p>
                    </Col>

                    <Col className="col-md">
                      <p className="titulo-column-imp">Costo por<br></br>participante</p>
                    </Col>

                    <Col>
                      <p className="titulo-column-imp">Subtotal</p>
                    </Col>
                  </Row>

                  <Row className="body-print-table">
                    <Col md={4} className="col-md">
                      <p>{COT?.catCursoNombre}</p>
                    </Col>
                    <Col md={2} className="col-md">
                      <p>{COT?.catCursoModalidad}</p>
                    </Col>
                    <Col>
                      <p>{COT?.participantes}</p>
                    </Col>
                    <Col className="col-md">
                      <p>Del {calculoFechas(COT?.fechaInicio)} <br></br>al {calculoFechas(COT?.fechaFinal)}</p>
                    </Col>
                    <Col className="col-md">
                      <p>{MilesQuota(COT?.catCursoMonto)}</p>
                    </Col>
                    <Col>
                      <p>{MilesQuota(COT?.monto)}</p>
                    </Col>
                  </Row>

                  <Row className="footer-print-table">

                    <Col xs={10} className="footer-pt-iz">
                      <p>TOTAL: <span className={isCheckedCap ? 'isCheckCap' : ''}>{Num2Let(COT?.descuento, "")}</span></p>
                    </Col>

                    <Col xs={2} className="footer-pt-dr">
                      <p>{MilesQuota(COT?.descuento)}</p>
                    </Col>

                  </Row>
                </Container>

                <Container className="cuenta-print-conv">
                  <p>La cuenta monetaria para depositar su pago por servicios académicos es del Banco de Desarrollo Rural-BANRURAL a nombre del ¨Instituto Nacional de Administración Pública -INAP-¨, Cuenta No.3033367653, NIT 3440737. Se puede hacer vía transferencia monetaria o por emisión de cheque, por lo cual se le extenderá Recibo 63-A2.</p>
                </Container>

                <Container className="notas-print-conv">
                  <Row className="notas-head-conv">
                    <p>Nota:</p>
                    <br />
                  </Row>
                  <Row className="notas-list-conv">
                    {
                      COT?.notas ? COT?.notas :
                        <ul>
                          <li>
                            La institución debe cancelar el costo por las personas inscritas (el trámite de pago se debe establecer antes de finalizar el curso).
                          </li>
                          <li>
                            El INAP enviará Diplomas digitales a cada participante aprobado al finalizar el curso.
                          </li>
                          <li>
                            INAP enviará Diplomas digitales a cada participante aprobado al finalizar el curso.
                          </li>
                          <li>
                            Se solicita que en el oficio de aceptación de la presente cotización, se proporcione los datos de la persona que será el enlace (nombre, cargo, correo electrónico y número telefónico) con quien la Dirección Financiera del INAP, deberá comunicarse para dar seguimiento al proceso de pago.
                          </li>
                          <li>
                            Para dar seguimiento a la presente cotización, es necesario que el solicitante remita un oficio de aceptación o bien, si ya se emitió la Solicitud de Compra de Bienes y/o Servicios, una copia de la misma.
                          </li>
                          <li>
                            Al aceptar la cotización, se trasladará un código para que cada participante pueda registrarse en la plataforma de INAP y realizar su proceso de inscripción al curso.
                          </li>
                        </ul>
                    }
                  </Row>
                </Container>

                <Container className="block-white"></Container>

                <Container className="indice-list-notes-print-body">
                  <Row>
                    <div className="indice-list-print-notes">1</div>
                    <div className="list-print-notes"><p>Razón Social de la Empresa: INSTITUTO NACIONAL DE ADMINISTRACIÓN PÚBLICA -INAP-</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">2</div>
                    <div className="list-print-notes"><p>Nombre Comercial de la Empresa: INSTITUTO NACIONAL DE ADMINISTRACIÓN PÚBLICA -INAP-</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">3</div>
                    <div className="list-print-notes"><p>Domicilio Fiscal de la Empresa: Boulevard Los Próceres 16-40, zona 10</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">4</div>
                    <div className="list-print-notes"><p>Teléfono de oficina y/o Celular de la Empresa: 2419-8181 Celular Tesorería: 5946-0432 (provisional por falta de extensión)</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">5</div>
                    <div className="list-print-notes"><p>Correo electrónico de la Empresa: palvarez@inap.gob.gt; jgarcia@inap.gob.gt</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">6</div>
                    <div className="list-print-notes"><p>Fecha de la cotización {ImpHeadDate} </p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">7</div>
                    <div className="list-print-notes"><p>NIT de la empresa: 3440737</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">8</div>
                    <div className="list-print-notes"><p>Régimen Tributario de la Empresa: Entidad del Estado</p></div>
                  </Row>

                  <Row>
                    <div className="indice-list-print-notes">9</div>
                    <div className="list-print-notes"><p>Validez de la cotización (tiempo en que se sostiene la cotización): Del {calculoFechas(datac?.startedAt)} al {calculoFechas(datac?.endedAt)}</p></div>
                  </Row>

                </Container>

                <Container className="despedida-print-conv">
                  <p>Atentamente:</p>
                </Container>

                <Container className="firma-print-conv">

                  <p><span>{datac?.nombre ? datac?.nombre : "INAP - Instituto Nacional de Administración Pública"}</span></p>
                  <p>{datac?.puesto ? datac?.puesto : "Dirección General"}</p>
                  <p>{datac?.dependencia ? datac?.dependencia : "Dirección para el Fortalecimiento de la Gestión Institucional"}</p>

                </Container>

                <Container className="archivo-print-conv">
                  <Row>
                    <Col className="archivo-firma">
                      <p>
                        {datac?.archivo ? datac?.archivo : "C.C. Archivo"}
                      </p>
                    </Col>
                  </Row>
                </Container>

              </Container>

            </>
          )
        }

      </Container>

    );
  }

})